/**
 * Default document meta for web (also declared in app.config.js `web.description` — keep in sync for PWA manifest).
 * Favicon URL must stay aligned with app.config.js `web.favicon` (same CDN path: ASSET_PATHS.LOGO_WEBP).
 */
import { getAssetUrl, ASSET_PATHS } from '../../../constants/assets';

export const SITE_NAME = 'Zporti';
/**
 * Apex, not www. Ad networks fetch /app-ads.txt from the root domain named in the store
 * listing, and the IAB spec excludes 'www.' and 'm.' subdomains; Liftoff rejects www
 * outright. Canonical tags, JSON-LD, and the sitemap must all agree on this host.
 * www.zporti.com continues to serve (CORS and Android app links accept both).
 */
export const SITE_URL = 'https://zporti.com';

export const SITE_META_DESCRIPTION =
  'Zporti — sports prediction challenges with friends. Pick match winners, create challenges, and compete on your arena.';

export const SITE_FAVICON_URL = getAssetUrl(ASSET_PATHS.LOGO_WEBP);

// Replace with a 1200×630 social preview image when one is created
export const SITE_OG_IMAGE_URL = getAssetUrl(ASSET_PATHS.LOGO_WEBP);

export const SITE_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: SITE_NAME,
  url: SITE_URL,
  description: SITE_META_DESCRIPTION,
  applicationCategory: 'SportsApplication',
  operatingSystem: 'iOS, Android, Web',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
  },
} as const;
